<template>
  <div>
    <Header v-if="this.$store.getters.isOturum"></Header>
    <router-view></router-view>
    <Footer v-if="this.$store.getters.isOturum"></Footer>
    <div class="bgLogo" v-if="Logo"
         :style="'background-image:url(https://cdn.mudu.pro/Drive/upload/1/Genel/'+Logo+')'"></div>
  </div>
</template>
<script>
import Header from './components/Doc/Header'
import Footer from './components/Doc/Footer'
import {router} from "./router";

export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      lo: false,
      Logo: null
    }
  },
  beforeCreate() {
    document.title = 'Aidatım | Yeni Nesil Yönetici Asistanı';
  },
  created() {
    this.$store.dispatch("initAuth");
    this.Logo = JSON.parse(localStorage.getItem('_aiHizmet'))['Logo'];
    window.addEventListener('contextmenu', event => {
      /*console.log(event);
      event.returnValue = false;*/
    });

    // window.addEventListener('keyup', event => {
    //   if (event.key === "F1") router.push("/panel");
    //   if (event.key === "F2") router.push("/yonetim");
    //   if (event.key === "F3") router.push("/vezne");
    //   if (event.key === "F4") router.push("/muhasebe");
    //   if (event.key === "F5") router.push("/raporlama");
    //   if (event.key === "F6") router.push("/icra");
    //   if (event.key === "F7") router.push("/iletisim");
    //   if (event.key === "F8") router.push("/iptal");
    // });


  }
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue